import {Reducer} from "redux";

import * as c from "./queue.constant";

export interface QueueNumber {
    counterName: string,
    counterNumber: string,
    lastModified: string
}
export interface QueueNumberState {
    current: QueueNumber;
    previous: QueueNumber;
}

const initialState: QueueNumberState = {
    current: {
        counterName: '',
        counterNumber: '',
        lastModified: ''
    },
    previous: {
        counterName: '',
        counterNumber: '',
        lastModified: ''
    }
}

const reducer: Reducer<QueueNumberState> = (state = initialState, action): QueueNumberState => {
    const { type, payload } = action;
    if (type === c.SET_QUEUE) {
        state.previous = {...state.current};
        state.current = {...payload}
        return {
            ...state
        };
    }
    return state
}


export default reducer;